import { Component, OnInit,ElementRef, ViewChild,AfterViewInit } from '@angular/core';
import { MDBModalRef,MDBModalService } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';
import { saveAs } from 'file-saver';

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { DetArchivoService } from 'src/app/service/det-archivo.service';
import { MaeProcesoService } from 'src/app/service/mae-proceso.service';

import { Response_dml_bean } from 'src/app/model/response-dml';
import { Console } from 'console';

@Component({
  selector: 'app-dml-envio-firma',
  templateUrl: './dml-envio-firma.component.html',
  styleUrls: ['./dml-envio-firma.component.scss']
})

export class DmlEnvioFirmaComponent implements OnInit {
   //variables enviado desde el padre
  action: Subject<Response_dml_bean> = new Subject();
  x_titulo:String;
  id_constancia:String;
  id_participante:String;
  x_uid:String;
  x_informacion:String;


  esmasivo:boolean;

  //archivo
  x_fileDoc:File=null;
  @ViewChild('labelArchivoDoc')
  labelArchivoDoc: ElementRef;

  x_filePdf:File=null;
  @ViewChild('labelArchivoPdf')
  labelArchivoPdf: ElementRef;

  seactualiza:boolean=false;

  constructor(
    public  modalRefEnvioFirmaDml: MDBModalRef,
    private utilitarioService:UtilitarioService,
    private detArchivoService:DetArchivoService,
    private maeProcesoService:MaeProcesoService,
    ){}

  ngOnInit(): void {
    this.esmasivo= this.id_participante=='0';
    console.log(this.esmasivo);
  }

  onFileDocChange(files: FileList){

    this.labelArchivoDoc.nativeElement.innerText = Array.from(files)
      .map(f => f.name)
      .join(', ');

    this.x_fileDoc = files.item(0);
    console.log(files.item(0));

  }
  onFilePdfChange(files: FileList){

    this.labelArchivoPdf.nativeElement.innerText = Array.from(files)
      .map(f => f.name)
      .join(', ');

    this.x_filePdf = files.item(0);
    console.log(files.item(0));

  }
  onMostrarActualizar(semuestr:boolean){

    if(semuestr)
    {
      this.seactualiza=true;
    }
    else
    {
      this.seactualiza=false;
      this.x_fileDoc = null;
    }
  }

  onDescargarArchivo()
  {
    this.utilitarioService.loading = true;
    this.detArchivoService.getFile(this.x_uid.toString()).subscribe(blob=>{
      this.utilitarioService.loading = false;
      saveAs(blob,"plantilla_word_"+this.id_participante+".docx");
    });
  }

  onEnviarFirma()
  {

    if (this.validarFormulario()==false){
      return false;
    }

    this.utilitarioService.loading = true;
    let formData = new FormData;

    formData.append("file",this.x_filePdf);

    //se registra el envio a firma
    this.maeProcesoService.enviarfirma(formData,this.id_constancia.toString(),this.id_participante.toString()).subscribe( (response_dml_bean : Response_dml_bean) => {

      this.utilitarioService.loading=false;
      this.action.next(response_dml_bean);
      this.onClosemodal();
    },
    error=>{
      this.utilitarioService.toastrError("Hubo un error al enviar a firmar el PDF." + error.error.messages.toString());
      this.utilitarioService.loading=false;
    });
  }

  onActualizarPlantilla(){

    if (this.x_fileDoc==null){
      this.utilitarioService.toastrError("Seleccione un archivo.");
      return false;
    }
    if (this.x_fileDoc.size<=0){
      this.utilitarioService.toastrError("Seleccione un archivo.");
      return false;
    }

    this.utilitarioService.loading=true;
    // se sube el archivo con actualizacion del archivo
    let formData = new FormData;

    formData.append("file",this.x_fileDoc);
    this.detArchivoService.uploadPlantilla(formData,this.id_constancia.toString(),this.id_participante.toString()).subscribe( (response_dml_bean : Response_dml_bean) => {

      this.utilitarioService.loading=false;
      if (response_dml_bean.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(response_dml_bean.mensaje);
        this.x_uid = response_dml_bean.codigoRegistroBD;
        this.onMostrarActualizar(false);
      }
      else
        this.utilitarioService.toastrError(response_dml_bean.mensaje);
      console.log(response_dml_bean);
    },
    error=>{
      this.utilitarioService.toastrError("Hubo un error al guardar el archivo." + error.error.messages.toString());
      this.utilitarioService.loading=false;
    });
  }

  onGenerarJuntado(){
    this.utilitarioService.loading = true;
    this.maeProcesoService.juntarwords(this.id_constancia.toString()).subscribe(blob=>{
      this.utilitarioService.loading = false;
      saveAs(blob,"plantillas_word_all_"+this.id_constancia+".docx");
      this.x_informacion = 'Se descargo el archivo word para su revision, guarde en PDF y seleccione a continuacion:';
    },
    error=>{
      this.maeProcesoService.juntarwords(this.id_constancia.toString()).subscribe(blob=>{
        this.utilitarioService.loading = false;
        saveAs(blob,"plantillas_word_all_"+this.id_constancia+".docx");
        this.x_informacion = 'Se descargo el archivo word para su revision, guarde en PDF y seleccione a continuacion:';
      },
      error=>{
        this.utilitarioService.loading=false;
        this.utilitarioService.toastrError("Hubo un error al juntar, intente nuevamente.");
        console.log(error.error.messages.toString());
      })
    });
  }
  validarFormulario() : Boolean{
    if (this.x_filePdf==null){
      this.utilitarioService.toastrError("Seleccione el archivo PDF del certificado.");
      return false;
    }
  }
  onClosemodal(){
    this.modalRefEnvioFirmaDml.hide();
  }

}
